export default __webpack_public_path__ + "static/media/ic-trashBlack.6786cbb2.svg";